import React, {Component} from "react";
import Axios from "axios";
import {getUrlExtension} from "../helpers/Helpers";
import {Alert, Button, Col, Form, FormControl, Modal, Row} from "react-bootstrap";
import shareImg from "../images/share-solid.svg";
import MultipleImagesPng from "./EditCampaign/multipleimages.png";
import "./FilePage.scss"
import axios from "axios";

export class FilePage extends Component {
    state = {
        campaign:{}
    };
    componentWillMount() {
        this.getCampaignAPI()
    }
    constructor(props) {
        super(props)
        this.uploadFiles = this.uploadFiles.bind(this)
    }
    getCampaignAPI(){
        let campaignId = this.props.match.params.campaignId;
        // let campaignId = this.props.match.params.campaignId;
        Axios.get(process.env.REACT_APP_BACKEND_URL + "/campaign/"+campaignId).then((response) => {
            if(response.data.message === "still looking"){
                setTimeout(()=>{
                    this.getCampaignAPI();
                },3000);
            }else{
                //loop through all boards to get unique fields
                let campaign = response.data.campaign;
                //json to clone; pointer issue
                this.setState({campaign: campaign});
            }
        }).catch(error => {
            if(error && error.response && error.response.data){
                this.setState({error:{title:"Error Finding Campaign!", body:error.response.data.message}});
            }
        });
    }
    uploadFiles(event){
        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;
        let data = new FormData();
        if(form["files"] && form["files"].files && form["files"].files.length){
            for(let file of form["files"].files){
                console.log(file);
                data.append("files",file);
            }
        }
        data.append("campaignId",this.state.campaign._id ? this.state.campaign._id : "");
        Axios.post(process.env.REACT_APP_BACKEND_URL + "/campaign/upload-files", data,{
            headers: {
                'content-type': 'multipart/form-data'
            }
        }).then(response => {
            this.setState({alert:{title:'Files Uploaded Successfully',body:form["files"].left + " files uploaded. May take a few minutes to complete."}})
            this.getCampaignAPI();//refresh page
        }).catch(error => {
            console.log(error.message)
            console.log(error.response)
            this.setState({error:{title:'Error uploading',body:error.data.message}})
        });
    }
    deleteFile(name){
        for(let i = 0; i < this.state.campaign.files.length;i++){
            if(this.state.campaign.files[i].name === name){
                this.state.campaign.files.splice(i, 1);
            }
        }
        this.setState({campaign: this.state.campaign});
        let data = new FormData();
        data.append("campaignId",this.state.campaign._id ? this.state.campaign._id : "");
        data.append("name",name);
        Axios.post(process.env.REACT_APP_BACKEND_URL + "/campaign/delete-file", data,{
            headers: {
                'content-type': 'multipart/form-data'
            }
        }).then(response => {
        }).catch(error => {
            console.log(error.message)
            console.log(error.response)
            this.setState({error:{title:'Error deleting',body:error.data.message}})
        });
    }

    isImage(src){
        let ext = getUrlExtension(src);
        ext = ext.toLowerCase();
        if(["jpg","png","jpeg","gif","svg"].includes(ext)){
            return true;
        }
        return false;
    }

    render() {
        let hasFiles = false;
        return <div className={"p-5"}>
            <div className={"d-flex justify-content-between flex-wrap align-items-center"}>
                <h1>{this.state.campaign.name}</h1>
                <div style={{flexBasis:"30%"}}>
                    {/*<Link to="/campaigns/create" className={"btn btn-primary btn-lg"}>*/}
                    {/*    + New*/}
                    {/*</Link>*/}
                    <FormControl
                        placeholder="Search..."
                        aria-label="Search..."
                        aria-describedby="basic-addon2"
                        value={this.state.search}
                        onChange={e => this.setState({ search: e.target.value })}
                    />
                </div>
            </div>
            <div className={"mt-4"}>
                <Button onClick={()=>this.setState({uploadModal:true})}>+ Upload Files</Button>
            </div>
            <div className={"d-flex mt-4"}>
                {this.state.campaign.files && this.state.campaign.files.map((f,index)=>{
                    if(this.state.search && !f.name.toLowerCase().includes(this.state.search.toLowerCase())){
                        return <></>
                    }
                    hasFiles = true;
                    return <div className={"m-2 file-card"}>
                        <div style={{lineHeight:0,background:"white"}}>
                            {function () {
                                if(this.isImage(f.src)) {
                                    return <img style={{height: 240,display:"block"}} src={f.src} alt={f.name}/>
                                }else if(getUrlExtension(f.src).toLowerCase() === "pdf") {
                                    return <iframe style={{height: 240,width:240}} src={f.src} sandbox={"allow-downloads"}/>
                                }else {
                                    return <h4 className={"mt-5 pt-5 pb-5 text-center w-100 ft-lg"}>{f.mimetype}</h4>
                                }
                            }.bind(this)()}
                        </div>
                        <div className={"d-flex justify-content-between mt-1"}>
                            <div style={{maxWidth:'calc(100% - 50px)',overflow:"hidden"}}>{f.name}</div>
                            <div>
                                <a role={"button"} download className={"m-1 text-secondary"} target={"_blank"} href={f.src}><i className="fa-solid fa-download"/></a>
                                <span role={"button"} className={"m-1"} onClick={()=>{
                                    this.deleteFile(f.name);
                                }}><i className="fa-solid fa-trash-can red-txt"/></span>
                            </div>
                        </div>
                    </div>
                })}
            </div>
            {!hasFiles && <h4 className={"mt-5 pt-5 pb-5 text-center w-100 ft-lg"}>No Files Found</h4>}
            <div className={"mt-5 text-center"}>
                <Button onClick={()=>this.setState({uploadModal:true})} className={"btn btn-primary btn-lg m-auto"}>+ Upload Files</Button>
            </div>
            {this.state.error ? (
                <Alert style={{maxWidth:500,position:"fixed",right:0,top:0}} className={"mx-auto"}  variant="danger" onClose={()=>{this.setState({error: null})}} dismissible>
                    <Alert.Heading>{this.state.error.title}</Alert.Heading>
                    <p>{this.state.error.body}</p>
                </Alert>
            ):(
                <></>
            )}
            {this.state.alert ? (
                <Alert style={{maxWidth:500}} className={"mx-auto alert-top-right"}  variant="success" onClose={()=>{this.setState({alert: null})}}  dismissible>
                    <Alert.Heading>{this.state.alert.title}</Alert.Heading>
                    <p>{this.state.alert.body}</p>
                </Alert>
            ):(
                <></>
            )}
            <Modal show={this.state.uploadModal} onHide={()=>{
                this.setState({uploadModal:false})
            }}>
                <Form onSubmit={this.uploadFiles}>
                    <Modal.Header closeButton>
                        <Modal.Title>+ Upload Files</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Upload multiple files. Do not upload a .zip or a folder.<br/>Example:
                        <img className={"d-block"} style={{width:200}} src={MultipleImagesPng} alt={"How to select multiple files"}/>
                        <Row className={"mt-4"}>
                            <Col className={"text-center col-6 mt-1"}>
                                <FormControl type="file" name="files" multiple="multiple"/>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <span onClick={()=>{
                            this.setState({uploadModal:false})
                        }} className={"mr-4 boring-btn"}>Close</span>
                        <Button variant="primary" type="submit">
                            Save Changes
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </div>
    }
}
